import contactsStyle from './contacts.module.css';

export function Contacts() {
  return (
    <div className={contactsStyle.div}>
      Контакты
    </div>
  );
}
